var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 15.1385C14.4706 15.1385 18.5 11.7496 18.5 7.56923C18.5 3.38886 14.4706 0 9.5 0C4.52944 0 0.5 3.38886 0.5 7.56923C0.5 9.9326 1.78789 12.043 3.80561 13.4311V18L7.63502 14.9757C8.23672 15.0824 8.86057 15.1385 9.5 15.1385Z",
    fill: "#371C1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.15f94fb96b8b939847582c4867e95017.svg";
export { ForwardRef as ReactComponent };